<template>
  <div class="item-description flex-grow">
    <a
      v-if="packageId && !isBookingPortal"
      :href="packagePath"
      class="in-cart-package-link"
      role="button"
    >
      <span class="name flex-grow font-weight-600"> {{ name }}</span>
    </a>
    <span
      v-else
      class="name flex-grow font-weight-600"
    >
      {{ name }}
    </span>
    <span
      class="item-price"
    >{{ price }}</span>
    <div
      v-if="isHotelItem && item && (item?.hotel_reservations?.[0]?.hotel_check_in_date || item?.contract_check_in)"
      class="quote-hotel-check-in-out-dates"
    >
      <span>{{ reformatCheckIn }},</span> <span>{{ reformatCheckOut }}</span>
    </div>

    <div
      v-else-if="item && item.hotel_reservations && item.hotel_reservations.length > 0"
    >
      <div class="hotel-dates">
        {{ item.hotel_reservations[0].hotel_check_in_date }} - {{ item.hotel_reservations[0].hotel_check_out_date }}
      </div>
    </div>
    <div
      v-if="order && order.order_type!='WebOrder'"
      class="quote-products-modal"
    >
      <QuoteProductsModal
        v-show="isModalVisible"
        :product-names="productNames"
        :name="name"
        @close="closeModal"
      />
    </div>

    <div
      v-if="ers"
      class="errors"
    >
      <span>{{ ers }}</span>
      <span
        class="delete"
        @click="ers = null"
      />
    </div>
  </div>
</template>

<script>
/* global locale */
import QuoteProductsModal from './q2oo_modal'
import {mapActions, mapMutations} from 'vuex'
import moment from 'moment'

export default {

  components: {
    QuoteProductsModal
  },

  props: {
    candelete: {
      default: '',
      type: String
    },
    eventname: {
      default: null,
      type: String
    },
    itemid: {
      default: 0,
      type: Number
    },
    item: {
      default: () => {},
      type: Object
    },
    name: {
      default: null,
      type: String
    },
    price: {
      default: null,
      type: String
    },
    packageId: {
      default: 0,
      type: Number
    },
    productNames: {
      default: () => [],
      type: Array
    },
    isHotelItem: {
      default: false,
      type: Boolean
    },
    isBookingPortal: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      ers: null,
      // itemQty: 1,
      isModalVisible: false,
      packagePath: `/${locale}/packages/${this.packageId}/path`
    }
  },

  computed: {
    updating(){
      return this.$store.state.order.loading
    },
    order(){
      return this.$store.state.order.order
    },
    reformatCheckIn() {
      const checkIn = this.item?.hotel_reservations?.[0]?.hotel_check_in_date_yyyy_mm_dd || this.item?.contract_check_in_date_yyyy_mm_dd

      return checkIn ? `${this.$t('h4h.checkIn')}: ${moment(checkIn).format('LL')}` : ''
    },
    reformatCheckOut(){
      const checkOut = this.item?.hotel_reservations?.[0]?.hotel_check_out_date_yyyy_mm_dd || this.item?.contract_check_out_date_yyyy_mm_dd

      return checkOut ? `${this.$t('h4h.checkOut')}: ${moment(checkOut).format('LL')}` : ''
    },
  },

  methods: {
    ...mapActions('order', ['getBackendOrder']),
    ...mapMutations('order', ['updateLoading']),

    closeModal() {
      this.isModalVisible = false
    }
  }
}
</script>
